const A = {
  Initiated: "INITIATED",
  InitiatedFailed: "INITIATED_FAILED",
  PartialAuthorized: "PARTIAL_AUTHORIZED",
  Authorized: "AUTHORIZED",
  AuthorizeFailed: "AUTHORIZE_FAILED",
  Captured: "CAPTURED",
  PartialCaptured: "PARTIAL_CAPTURED",
  CapturedFailed: "CAPTURED_FAILED",
  Void: "VOID",
  Verified: "VERIFIED",
  InitiateRefund: "INITIATE_REFUND",
  Refunded: "REFUNDED",
  Awaited: "AWAITED",
  Aborted: "ABORTED",
  Cancelled: "CANCELLED",
  CancelPending: "CANCEL_PENDING",
  CancelFailed: "CANCEL_FAILED",
  VerifiedFailed: "VERIFIED_FAILED"
};
export {
  A
};
//# sourceMappingURL=PaymentStatus-0db731f0.mjs.map
